import { setIframePath } from '@/utils/cookies'
const state = {
    cached_views: null,
    iframe_path: null,
}
const mutations = {
    setCachedViews (state: any, user_token: string) {
        state.cached_views = user_token
    },
    setIframePath (state: any, iframe_path: string) {
        setIframePath(iframe_path)
        state.iframe_path = iframe_path
    }
}
const actions = {
    setCachedViews(context: any, user_token: string) {
        context.commit('setCachedViews', user_token)
    },
    setIframePath(context: any, iframe_path: string) {
        context.commit('setIframePath', iframe_path)
    },
}
export default {
    state,
    mutations,
    actions
}